import { FC } from 'react';

import { formatTime, isSignificantlyDelayedOrAhead } from '@/utils/dateUtils';

import styles from './MwdTooltipVertrekRow.module.css';

const STRINGS = {
  VAN: 'Van: ',
  VERTREK: 'Vertrek: ',
  DRGL_WIJZIGING: ' (drgl wijziging)',
};

type MwdTooltipVertrekRowProps = {
  oorspronkelijkePlanTijd: Date;
  actuelePlanTijd: Date;
  uitvoeringsTijd: Date;
  dienstregelpuntVan?: string;
  hasAnyConflict?: boolean;
  isOvergang?: boolean;
};

const MwdTooltipVertrekRow: FC<MwdTooltipVertrekRowProps> = ({
  oorspronkelijkePlanTijd,
  actuelePlanTijd,
  uitvoeringsTijd,
  dienstregelpuntVan,
  hasAnyConflict = false,
  isOvergang = false,
}) => {
  const isUitvoeringAfwijkend = isSignificantlyDelayedOrAhead(oorspronkelijkePlanTijd, uitvoeringsTijd);
  const isDienstregelingGewijzigd = isSignificantlyDelayedOrAhead(oorspronkelijkePlanTijd, actuelePlanTijd);

  return (
    <div className={styles.row} data-testid='mwd-tooltip-vertrek'>
      {isOvergang ? STRINGS.VERTREK : STRINGS.VAN}
      <span className={isUitvoeringAfwijkend ? styles.strikeThrough : undefined}>
        {formatTime(oorspronkelijkePlanTijd)}
      </span>{' '}
      {isUitvoeringAfwijkend && (
        <span className={oorspronkelijkePlanTijd < uitvoeringsTijd ? styles.delayed : styles.ahead}>
          <strong>{formatTime(uitvoeringsTijd)}</strong>
        </span>
      )}
      {isOvergang ? (
        ' '
      ) : (
        <span className={hasAnyConflict ? styles.conflict : undefined}>{` ${dienstregelpuntVan}`}</span>
      )}
      {isDienstregelingGewijzigd ? STRINGS.DRGL_WIJZIGING : ' '}
    </div>
  );
};

export default MwdTooltipVertrekRow;
